import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { ArrowUp, ArrowDown, Trash2, Plus } from "lucide-react";
import { toast } from "sonner";

export default function AdminNavigation() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/navigation/admin/all").then(r => setItems(r.data)); }, []);
  const upd = (i, patch) => setItems(l => l.map((it, j) => j === i ? { ...it, ...patch } : it));
  const move = (i, d) => setItems(l => { const n = [...l]; const j = i + d; if (j < 0 || j >= n.length) return l; [n[i], n[j]] = [n[j], n[i]]; return n; });
  const save = async () => {
    if (items.some(it => !it.label.trim() || !it.link.trim())) return toast.error("Every menu item needs a label and a link");
    try { const r = await api.put("/navigation", items.map(({ id, label, link, visible, new_tab }) => ({ id, label, link, visible, new_tab }))); setItems(r.data); toast.success("Menu saved"); }
    catch { toast.error("Save failed"); }
  };
  return (
    <div>
      <div className="flex items-center justify-between mb-6"><h1 className="font-heading font-extrabold text-2xl">Navigation Menu</h1>
        <div className="flex gap-2">
          <Button variant="outline" onClick={() => setItems([...items, { label: "", link: "/", visible: true, new_tab: false }])} data-testid="nav-add"><Plus className="w-4 h-4 mr-1"/> Add Link</Button>
          <Button className="btn-orange" onClick={save} data-testid="nav-save">Save Menu</Button>
        </div></div>
      <p className="text-sm text-slate-600 mb-4">Links shown in the header (desktop and mobile). Use internal paths like <code>/products</code> or full URLs.</p>
      <div className="bg-white border border-[#E2E8F0] rounded-md divide-y divide-[#E2E8F0] max-w-4xl">
        {items.map((it, i) => (
          <div key={it.id || i} className="p-3 grid grid-cols-12 gap-2 items-center" data-testid={`nav-item-${i}`}>
            <div className="col-span-1 flex flex-col"><button onClick={() => move(i, -1)} className="hover:text-[#EA580C]" data-testid={`nav-up-${i}`}><ArrowUp className="w-4 h-4"/></button><button onClick={() => move(i, 1)} className="hover:text-[#EA580C]" data-testid={`nav-down-${i}`}><ArrowDown className="w-4 h-4"/></button></div>
            <Input className="col-span-4" placeholder="Label" value={it.label} onChange={e => upd(i, { label: e.target.value })} data-testid={`nav-label-${i}`}/>
            <Input className="col-span-4" placeholder="/link" value={it.link} onChange={e => upd(i, { link: e.target.value })} data-testid={`nav-link-${i}`}/>
            <label className="col-span-2 flex items-center gap-2 text-xs"><Switch checked={it.visible} onCheckedChange={v => upd(i, { visible: v })} data-testid={`nav-visible-${i}`}/> Visible</label>
            <button className="col-span-1 text-red-500 justify-self-end" onClick={() => setItems(items.filter((_, j) => j !== i))} data-testid={`nav-remove-${i}`}><Trash2 className="w-4 h-4"/></button>
          </div>
        ))}
      </div>
    </div>
  );
}
